import React from "react";
import OrdersAvailablePage from "./OrdersAvailablePage";
import { TRANSPORTATION_TYPES } from "../utils/railwayOrder";

const RailwayOrdersAvailablePage = () => (
  <OrdersAvailablePage transportationType={TRANSPORTATION_TYPES.RAILWAY} />
);

export default RailwayOrdersAvailablePage;
